/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Sv } from './Sv';

const { GlobalVar } = Utils;

class CertExam extends Sv {
    constructor() {
        super();
        this.baseUrl += '/certExam';
    }

    data({
        certCatId,
        certExamType,
        applyTemplateId,
        appraisalRuleId,
        paperTemplateId,
        certExamCourseId,
        isAvailable,
        schoolOrgId,
        classExaminationType,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            certCatId,
            certExamType,
            applyTemplateId,
            appraisalRuleId,
            paperTemplateId,
            certExamCourseId,
            isAvailable,
            schoolOrgId,
            classExaminationType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { groupQrCode } = json.data.data;
            if (!groupQrCode) {
                json.data.data.groupQrCode = [];
            } else {
                json.data.data.groupQrCode = groupQrCode.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            const { applyNotice } = json.data.data;
            if (!applyNotice) {
                json.data.data.applyNotice = [];
            } else {
                json.data.data.applyNotice = applyNotice.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        id,
        certCatId,
        certExamType,
        applyTemplateId,
        appraisalRuleId,
        paperTemplateId,
        certExamCourseId,
        admitCardTemplateId,
        isAvailable,
        schoolOrgId,
        certExamDesc,
        groupQrCode,
        applyNotice,
    } = {}) {
        const groupQrCodeStr = groupQrCode
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const applyNoticeStr = applyNotice
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            certCatId,
            certExamType,
            applyTemplateId,
            appraisalRuleId,
            paperTemplateId,
            certExamCourseId,
            admitCardTemplateId,
            isAvailable,
            schoolOrgId,
            certExamDesc,
            groupQrCode: groupQrCodeStr,
            applyNotice: applyNoticeStr,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }
}

export default new CertExam();
export { CertExam };
